import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ResolveEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class NavigationService {
    private currentUrlSubject = new BehaviorSubject<string>('/');
    currentUrl$ = this.currentUrlSubject.asObservable();
  
    constructor(private router: Router) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (event.urlAfterRedirects !== '/error/page-500') {
            this.currentUrlSubject.next(event.urlAfterRedirects);
          }
        }
      });
    }
  
    getCurrentUrl(): string {
      return this.currentUrlSubject.value;
    }
  
    setCurrentUrl(url: string): void {
      if (url !== '/error/page-500' && url !== '/auth/logout') {
        this.currentUrlSubject.next(url);
      }
    }
    
  }